import { isValidPhoneNumber } from 'libphonenumber-js'
import * as v from 'valibot'
import { DEFAULT_COUNTRY } from '#shared/utils/countries'
import { DateOfBirthSchema } from '#shared/utils/dateOfBirth'

const REQUIRED = 'This field is required'

function requiredString(max: number) {
  return v.pipe(v.string(REQUIRED), v.trim(), v.nonEmpty(REQUIRED), v.maxLength(max))
}

export const LeadSchema = v.object({
  firstName: requiredString(255),
  lastName: requiredString(255),
  dateOfBirth: DateOfBirthSchema,
  email: v.pipe(requiredString(255), v.email('Please enter a valid email address')),
  // No country field here: numbers without an international prefix are read as UK ones.
  mobile: v.pipe(
    requiredString(32),
    v.check(value => isValidPhoneNumber(value, DEFAULT_COUNTRY), 'Please enter a valid mobile number'),
  ),
  message: requiredString(5000),
  marketingConsent: v.optional(v.boolean(), false),
  // Honeypot: real users never see this field, bots tend to fill it in.
  company: v.optional(v.string(), ''),
})

export type Lead = v.InferOutput<typeof LeadSchema>
